import React from 'react';

interface TypingIndicatorProps {
  activityText?: string | null;
}

/**
 * TypingIndicator component
 * Shows animated typing dots with optional activity text label.
 * Purely visual: the screen-reader announcement lives in ChatWindow's
 * always-mounted status region — this component mounts together with its
 * content, and a live region inserted with content is not announced.
 */
export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ activityText }) => {
  return (
    <div className="omq-chatbot-typing-indicator">
      <div className="omq-chatbot-typing-dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      {activityText && <div className="omq-chatbot-activity-text">{activityText}</div>}
    </div>
  );
};
